var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4413 7.99935L21.4146 4.97268C21.508 4.41268 21.6546 3.89268 21.8413 3.43935C21.9693 3.13574 22.0202 2.80517 21.9895 2.47711C21.9588 2.14905 21.8474 1.83369 21.6652 1.55912C21.4831 1.28456 21.2358 1.05933 20.9455 0.9035C20.6552 0.747671 20.3308 0.666086 20.0013 0.666016C17.8146 0.666016 15.8813 1.71935 14.668 3.33268H8.0013C3.94797 3.33268 0.667969 6.61268 0.667969 10.666C0.667969 14.7193 4.0013 25.9993 4.0013 25.9993H11.3346V23.3327H14.0013V25.9993H21.3346L23.5746 18.546L27.3346 17.2927V7.99935H24.4413ZM15.3346 9.99935H8.66797V7.33268H15.3346V9.99935ZM19.3346 12.666C18.6013 12.666 18.0013 12.066 18.0013 11.3327C18.0013 10.5993 18.6013 9.99935 19.3346 9.99935C20.068 9.99935 20.668 10.5993 20.668 11.3327C20.668 12.066 20.068 12.666 19.3346 12.666Z",
    fill: "#148BD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureImg2);
export default __webpack_public_path__ + "static/media/featureImg2.e38bcbfec7abffccbd157ac03c9e6b9e.svg";
export { ForwardRef as ReactComponent };